import React from "react"
import InfoDialog from "../../feedback/InfoDialog"
import {LineItem} from "../../../dtos/orderResponse"
import {Event} from "../../../dtos/eventResponse"
import OrderService from "../../../services/order/OrderService"
import {Grid, Typography} from "@mui/material"
import TooltipLabel from "../../toolTip/TooltipLabel"

interface LineItemStateProps {
	orderNumber: string
	lineItem: LineItem
	itemNumber: number
	trackingDetails?: Map<string, Event[]>
	itemStatus: string
}

export default function LineItemState(props: LineItemStateProps) {
	const {lineItem} = props

	const [rejectionReason, setRejectionReason] = React.useState("")
	const [failureReason, setFailureReason] = React.useState("")

	function isCancelled(): boolean {
		return ["Cancelled", "CancelRequested", "CancelSuccess"].includes(
			lineItem.states?.[lineItem.states.length - 1]?.state
		)
			? true
			: false
	}
	function isCancelledOrRejected(): boolean {
		return ["Cancelled", "CancelRequested", "CancelSuccess", "Rejected", "FailedItem"].includes(
			getItemStatus()
		)
	}

	let shippedQty = (function shippedQuantity(): number {
		let qty = 0
		lineItem.states.forEach((element) => {
			if (element.state.toLowerCase() === "shipped") qty += element.quantity
		})
		return qty
	})()
	async function getRejectionReason() {
		const svc = new OrderService()
		await svc
			.getRejectedtEvent(props.orderNumber, props.lineItem.id, props.itemNumber)
			.then((event: Event) => {
				const reason =
					event &&
					event.eventProperties &&
					event.eventProperties.mcpEvent[0] &&
					JSON.parse(event.eventProperties.mcpEvent[0]).eventType === "fulfillerRejected" &&
					JSON.parse(event.eventProperties.mcpEvent[0]).fulfillerRejectedDetails &&
					JSON.parse(event.eventProperties.mcpEvent[0]).fulfillerRejectedDetails[0]
						? JSON.parse(event.eventProperties.mcpEvent[0]).fulfillerRejectedDetails[0]
								.additionalInfo
						: "Could not find the rejection reason"
				setRejectionReason(reason)
			})
	}

	async function getFailureReason() {
		const svc = new OrderService()
		await svc
			.getFailedEvent(props.orderNumber, props.lineItem.id)
			.then((event: Event) => {
				let reason = "Cannot find a reason."
				if (
					event.itemInfo[0] &&
					event.itemInfo[0].itemProperties &&
					event.itemInfo[0].itemProperties.failureDetails &&
					event.itemInfo[0].itemProperties.failureDetails.reason
				) {
					reason = event.itemInfo[0].itemProperties.failureDetails.reason
				}
				if (
					event.eventProperties &&
					event.eventProperties.mcpApiErrorResponse &&
					event.eventProperties.mcpApiErrorResponse.validationErrors &&
					event.eventProperties.mcpApiErrorResponse.validationErrors[0].message
				) {
					reason = event.eventProperties.mcpApiErrorResponse.validationErrors[0].message
				}
				setFailureReason(reason)
			})
			.catch((err) => {
				setFailureReason("Cannot find a reason")
			})
	}
	const getItemStatus = () => {
		return isCancelled() ||
			["Rejected", "FailedItem"].includes(lineItem.states[lineItem.states.length - 1].state)
			? lineItem.states[lineItem.states.length - 1].state
			: props.itemStatus
	}

	return (
		<Grid container justifyContent="space-between">
			<Grid item xs={lineItem.states[0].state === "Rejected" ? 6 : 12}>
				{getItemStatus() === "Order created" ? (
					<TooltipLabel
						toolTipHintText={`This item is initialized but has not been sent to MCP yet.`}
						labelTitle=""
					>
						<Typography>
							<strong style={{color: "green"}}>{props.itemStatus}</strong>
						</Typography>
					</TooltipLabel>
				) : (
					<Typography>
						<strong style={isCancelledOrRejected() ? {color: "red"} : {color: "green"}}>
							{getItemStatus()}

							{props.itemStatus === "Shipped" && shippedQty > 0
								? `(${shippedQty}/${lineItem.quantity})`
								: ""}
						</strong>
					</Typography>
				)}
			</Grid>
			<Grid item xs={6} style={lineItem.states[0].state === "Rejected" ? {} : {display: "none"}}>
				<InfoDialog
					buttonName={"Reason"}
					title={"Rejection Reason"}
					body={rejectionReason}
					handleClick={getRejectionReason}
				/>
			</Grid>
			<Grid item xs={6} style={lineItem.states[0].state === "FailedItem" ? {} : {display: "none"}}>
				<InfoDialog
					buttonName={"Reason"}
					title={"Failure Reason"}
					body={failureReason}
					handleClick={getFailureReason}
				/>
			</Grid>
		</Grid>
	)
}
